import CryptoJS from 'crypto-js';

/** Hex-encoded SHA-256 of a string. */
export function sha256(input: string): string {
  return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
}
